import { useEffect, useRef, useState } from "react";
import { Button, Divider, Dropdown, Empty, Menu } from "antd"; //message
import { Link, useNavigate } from "react-router-dom";
import { EditOutlined, CloseOutlined, CalendarOutlined, LockOutlined, CheckCircleOutlined } from "@ant-design/icons";
import Bills from "./Bills";
import TrackingHistory from "./TrackingHistory";
import OrderdetailTabs from "./OrderdetailTabs";
import DeliveryDetail from "./DeliveryDetail";
import DriverDetail from "./DriverDetail";
import BranchDetails from "./BranchDetails";
import CustomerConfirmation from "../../../../Modal/CustomerConfirmation";
import CancelOrder from "../../../../Modal/CancelOrder";
import { checkPermissionAction, formatDateFunction } from "../../../../utils/helper/utils";
import globalRequest from "../../../../utils/global/globalRequest";
import * as Apis from "../../../../utils/helper/enum";
import toast from "react-hot-toast";
import { changeLoader } from "../../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import QcDetails from "./QcDetails";
import DriverLogs from "./DriverLogs";
import Reschedule from "../../../../Modal/Reschedule";
import RefundOrder from "../../../../Modal/RefundOrder";
import Otp from "../../../../Modal/Otp";
import Deductions from "../../../../Modal/Deductions";
import DeductionsDetails from "./DeductionsDetails";

const copyText = async (textToCopy, e) => {
  e.stopPropagation();
  try {
    await navigator.clipboard.writeText(textToCopy);
    toast.success("Copied to clipboard!");
  } catch (err) {
    toast.error("Failed to copy text");
  }
};

const OrderDetails = ({
  orderDetailId,
  orderDetailData,
  reloadPage,
  // getAllOrdersCount,
  qcRequestData,
  qcData,
  permissionJson,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const trackingHistoryRef = useRef(null);

  const scrollToTrackingHistory = () => {
    trackingHistoryRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const typeMapping = {
    qc: "QC",
    "qc-payment": "QC & Payment",
    "delivery-payment": "Delivery & Payment",
    "qc-delivery-payment": "QC, Delivery & Payment",
    delivery: "Delivery",
  };

  const [isCustomerConfirmationModalOpen, setIsCustomerConfirmationModalOpen] = useState(false);
  const [messageText, setMessageText] = useState("");
  const [modalStatus, setModalStatus] = useState("");

  // const [isMessageSuccess, successMessageContextHolder] = message.useMessage();
  const [isCancelOrderModel, setIsCancelOrderModel] = useState(false);
  const [isDeductionsModalOpen, setIsDeductionsModalOpen] = useState(false);
  const [isRescheduleModel, setRescheduleModel] = useState(false);
  const [isRefundOrderModel, setRefundOrderModel] = useState(false);
  const [submitToQcBtn, setSubmitToQcBtn] = useState(true);
  const [rejectedText, setRejectedText] = useState("");
  const [updatedTime, setUpdatedTime] = useState(true);
  const [vendorDetailsData, setVendorDetailsData] = useState([]);
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [selectedLockerNumber, setselectedLockerNumber] = useState(null);
  const [isSelectRangeModalOpen, setIsSelectRangeModalOpen] = useState(false);
  const [isReactivateModalOpen, setIsReactivateModalOpen] = useState(false);
  const showOtpModal = () => {
    setIsOtpModalOpen(true);
  };
  const handleOtpOk = () => {
    setIsOtpModalOpen(false);
  };
  const handleOtpCancel = () => {
    setIsOtpModalOpen(false);
  };
  const handelCancelOrderModelOk = () => {
    reloadPage();
    setIsCancelOrderModel(false);
  };
  const handelCancelOrderModelCancel = () => {
    setIsCancelOrderModel(false);
  };

  const handelRescheduleModelOk = () => {
    setRescheduleModel(false);
  };
  const handelRescheduleModelCancel = () => {
    setRescheduleModel(false);
  };
  const handelRefundOrderModelOk = () => {
    reloadPage();
    setRefundOrderModel(false);
  };
  const handelDeductionOrderModelOk = () => {
    reloadPage();
    setIsDeductionsModalOpen(false);
  };
  const handelRefundOrderModelCancel = () => {
    setRefundOrderModel(false);
  };

  const handleSelectRangeModalOk = () => {
    setIsSelectRangeModalOpen(false);
  };
  const handleSelectRangeModalCancel = () => {
    setIsSelectRangeModalOpen(false);
  };

  const isAutoCancelledByCron = () => {
    if (orderDetailData.status !== "cancelled") return false;
    
    const logs = orderDetailData.orderStatusLogs || [];
    if (logs.length === 0) return false;
    
    const lastLog = logs[logs.length - 1];
    return lastLog.status === "cancelled" && 
          lastLog.addedBy?.name === "auto cancelled by cron";
  };

  const reactivateCancelledOrder = async () => {
    try {
      dispatch(changeLoader(true));
      
      const response = await globalRequest(
        Apis?.ORDERS?.REACTIVATE_CANCELLED_ORDER,
        "post",
        { order_id: orderDetailData.id },
        {},
        true
      );

      if (response?.status === 200) {
        toast.success(response?.data?.message || "Order successfully reactivated!", {
          duration: 3000,
        });
        setIsReactivateModalOpen(false);
        reloadPage();
      } else {
        toast.error(response?.data?.message || "Failed to reactivate order");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || "An error occurred");
    } finally {
      dispatch(changeLoader(false));
    }
  };

  const handleCustomerConfirmationModalOk = async () => {
    if (modalStatus === "") sendRequestForApproval();
    if (modalStatus === "processing") updateOrderStatus("processing");
    if (modalStatus === "ready_to_pick") updateOrderStatus("ready_to_pick");
    if (modalStatus === "delivered") sendOtpToCustomers("delivered");
    if (modalStatus === "delay_message") sendDelayMessage();
    if (modalStatus === "openLocker") handleOpenLocker();
    if (modalStatus === "openLockerDelivered") handleLockerItemDelivered();
  };

  const sendRequestForApproval = async () => {
    //send request to customer here
    dispatch(changeLoader(true));
    let response = await globalRequest(Apis?.ORDERS?.SEND_REQUEST_FOR_APPROVAL + "/" + orderDetailData.id, "get", {}, {}, true);
    let apiResponse = response?.data;
    if (response?.status === 200) {
      let msg = "Approval is successfully sent to customer.";
      toast.success(msg, {
        duration: 2000,
      });
      setIsCustomerConfirmationModalOpen(false);
    } else {
      toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));
  };

  const updateOrderStatus = async (status) => {
    //send request to customer here
    dispatch(changeLoader(true));
    let response;
    if (status === "delivered") {
      response = await globalRequest(Apis?.ORDERS?.MOVED_TO_DELIVERD, "post", { order_id: orderDetailData.id }, {}, true);
    } else {
      response = await globalRequest(Apis?.ORDERS?.UPDATE_ORDER_STATUS + "/" + orderDetailData.id, "put", { status: status }, {}, true);
    }

    let apiResponse = response?.data;
    if (response?.status === 200) {
      let msg = "";
      if (status === "processing") msg = "Order successfully moved to 'Preparing'.";
      if (status === "ready_to_pick") msg = "Order successfully moved to 'Ready to ship'.";
      if (status === "delivered") msg = "Order successfully moved to 'Completed'.";

      toast.success(msg, {
        duration: 2000,
      });
      reloadPage();
      // getAllOrdersCount();
      setIsCustomerConfirmationModalOpen(false);
    } else {
      toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));
  };

  const sendOtpToCustomers = async (status) => {
    // setIsCustomerConfirmationModalOpen(false);
    // showOtpModal()
    dispatch(changeLoader(true));
    let response = await globalRequest(Apis?.ORDERS?.SEND_OTP, "post", { order_id: orderDetailData.id }, {}, true);
    // let apiResponse = response?.data;
    if (response?.status === 200) {
      toast.success(response?.data?.message, {
        duration: 2000,
      });
      setIsCustomerConfirmationModalOpen(false);
      showOtpModal();
    } else {
      // toast.error(apiResponse?.message);
      setIsCustomerConfirmationModalOpen(false);
      showOtpModal();
    }
    dispatch(changeLoader(false));
  };

  const sendDelayMessage = async () => {
    //send delay message to customer here
    dispatch(changeLoader(true));
    let response = await globalRequest(
      Apis?.ORDERS?.DELAY_MESSAGE_SEND,
      "post",
      {
        order_id: orderDetailData.id,
        mobile_no: orderDetailData?.userMobileNo,
      },
      {},
      true
    );
    let apiResponse = response?.data;
    if (response?.status === 200) {
      let msg = "Delay Message is successfully sent to customer.";
      toast.success(msg, {
        duration: 2000,
      });
      setIsCustomerConfirmationModalOpen(false);
    } else {
      toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));
  };

  const verifyComplateOrderOtp = async () => {
    updateOrderStatus("delivered");
    setIsOtpModalOpen(false);
  };

  const handleCustomerConfirmationModalCancel = () => {
    setIsCustomerConfirmationModalOpen(false);
  };

  useEffect(() => {
    if (!orderDetailData || !Array.isArray(orderDetailData.orderDetails) || orderDetailData.orderDetails.length === 0) {
      return;
    }

      let count = 0;
      let totalCount = 0;
      for (let item of orderDetailData.orderDetails) {
        if (orderDetailData.vendorId === item.vendorId && item.vendorType !== "host") {
          totalCount += 1;
          for (let item1 of qcRequestData) {
            if (item.id === item1.orderDetailId && (item1.status === "in_review" || item1.status === "approve")) {
              count += 1;
            }
          }
        }
      }
      if (totalCount === count) setSubmitToQcBtn(false);

      if (orderDetailData?.vendorId !== orderDetailData?.pickupVendorId) {
        let vendor1 = {};
        let vendor2 = {};
        for (let item of orderDetailData.orderDetails) {
          if (orderDetailData.vendorId === item.vendorId) vendor1 = item.vendorDetails || {};
          else vendor2 = item.vendorDetails || {};
        }

        let vendors = [vendor1];
        if (Object.keys(vendor2).length !== 0) vendors.push(vendor2);
        if (vendors.length > 0) {
          let vendorsData = [];
          for (let row of vendors) {
            let vendorsOrderDetail = [];
            for (let item of orderDetailData.orderDetails) {
              if (row.id === item.vendorId) vendorsOrderDetail.push(item);
            }
            vendorsData.push({
              vendorId: row?.id,
              vendorName: row?.vendorDetail?.storeName || "",
              orderDetails: vendorsOrderDetail,
            });
          }
          setVendorDetailsData(vendorsData);
        }
      }

      if (orderDetailData?.vendorId === orderDetailData?.pickupVendorId && orderDetailData?.pickupVendorId !== 0 && orderDetailData?.orderDetails?.[0]?.vendorDetails) {
        const firstVendorDetails = orderDetailData.orderDetails[0].vendorDetails || {};
        const firstVendorInfo = firstVendorDetails.vendorDetail || {};
        const firstVendorId = firstVendorDetails.id || null;
        const firstStoreName = firstVendorInfo.storeName || "";
        const firstVendorType = firstVendorInfo.vendor_type || "";

        let vendors = [
          {
            id: firstVendorId,
            storeName: firstStoreName,
            type: firstVendorType,
          },
          {
            id: firstVendorId,
            storeName: `${firstStoreName} (Featured)`,
            type: "host",
          },
        ];

        let vendorsData = [];
        for (let row of vendors) {
          let vendorsOrderDetail = [];
          for (let item of orderDetailData.orderDetails) {
            if (row.type === item.vendorType) vendorsOrderDetail.push(item);
          }
          vendorsData.push({
            vendorId: row.id,
            vendorType: row.type,
            vendorName: row.storeName,
            orderDetails: vendorsOrderDetail,
          });
        }
        setVendorDetailsData(vendorsData);
      }

    if (Array.isArray(orderDetailData.orderStatusLogs) && orderDetailData.orderStatusLogs.length > 0) {
      let count1 = orderDetailData.orderStatusLogs.length;
        let data = orderDetailData.orderStatusLogs[count1 - 1];
        if (data.status === "reject") {
          setRejectedText("Order rejected on");
        }
        setUpdatedTime(data.date);
    }
  }, [orderDetailData, qcRequestData, setSubmitToQcBtn]);

  const downloadInvoice = async (id) => {
    //send request to customer here
    dispatch(changeLoader(true));
    let response = await globalRequest(Apis?.ORDERS?.DOWNLOAD_INVOICE + "/" + id, "get", {}, {}, true);
    let apiResponse = response?.data;
    if (response?.status === 200) {
      //response?.data?.data
      let invoice_data = response?.data?.data;
      let byteArray = invoice_data?.split(",").map(Number);
      if (!byteArray || byteArray?.length === 0) {
        console.error("No byte array received.");
        return;
      }
      const pdfBlob = new Blob([new Uint8Array(byteArray)], {
        type: "application/pdf",
      }); //bytesToBlob(byteArray, "application/pdf");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      // window.open(pdfUrl);
      // Create a link to download the PDF
      const downloadLink = document.createElement("a");
      downloadLink.href = pdfUrl;
      downloadLink.download = "invoice.pdf"; // Set a file name for the download

      // Append the link to the DOM (hidden) and trigger the download
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
      }, 100);
    } else {
      toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));
  };

  const editCancelMenu = (
    <Menu>
      {checkPermissionAction("Order Management", permissionJson, "edit") && orderDetailData.status === "placed" && (
        <Menu.Item key="1" icon={<EditOutlined />} onClick={() => navigate("/edit-order/" + orderDetailData.id)}>
          Edit
        </Menu.Item>
      )}
      {checkPermissionAction("Order Management", permissionJson, "cancel") && orderDetailData.status !== "placed" && (
        <Menu.Item key="2" icon={<CloseOutlined />} onClick={() => setIsCancelOrderModel(true)}>
          Cancel
        </Menu.Item>
      )}
      {checkPermissionAction("Order Management", permissionJson, "reschedule") && orderDetailData?.timeSlotDetails && ( orderDetailData.status === "no_show" ||
          orderDetailData.status === "confirmed" ||
          orderDetailData.status === "processing" ||
          orderDetailData.status === "under_qa" ||
          orderDetailData.status === "ready_to_pick" ||
          orderDetailData.status === "pickup_delivered" ) && (
        <Menu.Item key="3" icon={<CalendarOutlined />} onClick={() => setRescheduleModel(true)}>
          Reschedule
        </Menu.Item>
      )}
        <>
          {checkPermissionAction("Order Management", permissionJson, "open_locker") && orderDetailData?.assignedLocker && orderDetailData.status === "pickup_delivered" && (
            <Menu.Item key="4" icon={<LockOutlined />}
              onClick={() => {
              setIsCustomerConfirmationModalOpen(true);
              setMessageText("You want to open the locker.");
              setModalStatus("openLocker");
            }}>
              Open Locker
            </Menu.Item>
          )}

          {checkPermissionAction("Order Management", permissionJson, "mark_complete") && (orderDetailData.status === "out_for_delivery" || orderDetailData.status === "pickup_delivered") && (
            <Menu.Item key="5" icon={<CheckCircleOutlined />}
              onClick={() => {
                setIsCustomerConfirmationModalOpen(true);
                setMessageText("You want to complete order without OTP");
                setModalStatus("openLockerDelivered");
              }}
              >
                Mark Complete(Skip OTP)
              </Menu.Item>
            )}
          </>
    </Menu>
  );
  const handleDeductionsCancel = () => {
    setIsDeductionsModalOpen(false);
  };

  const assignLockerToOrder = async (lockerNumber) => {
    dispatch(changeLoader(true));
    let response = await globalRequest(Apis?.ORDERS?.ASSIGN_LOCKER_TO_ORDER, "post", { order_id: orderDetailData.id, locker_number: lockerNumber }, {}, true);
    let apiResponse = response?.data;
    if (response?.status === 200) {
      toast.success(apiResponse?.message);
      setselectedLockerNumber(null);
      setIsSelectRangeModalOpen(false);
      reloadPage();
    } else {
      toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));
  };

  let lockerDetails = { range: orderDetailData?.pickupPointDetails?.range, deviceCode: orderDetailData?.pickupPointDetails?.deviceCode,};

  const handleOpenLocker = async () => {
     try {
      dispatch(changeLoader(true));
      let data = {};
      data.order_id = orderDetailData.id;
      let response = await globalRequest(Apis?.ORDERS?.OPEN_LOCKER, "post", data, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        toast.success(apiResponse?.message);
        setIsCustomerConfirmationModalOpen(false);
        reloadPage();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    } finally {
      dispatch(changeLoader(false));
    }
  };

  const handleLockerItemDelivered = async () => {
     try {
      dispatch(changeLoader(true));
      let data = {};
      data.order_id = orderDetailData.id;
      let response = await globalRequest(Apis?.ORDERS?.LOCKER_ITEM_DELIVERED, "post", data, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        toast.success(apiResponse?.message);
        setIsCustomerConfirmationModalOpen(false);
        reloadPage();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    } finally {
      dispatch(changeLoader(false));
    }
  }
  return (
    <>
      {parseInt(orderDetailId) > 0 ? (
        <div className="flex-auto pt-5 w-[calc(100%-320px)]">
          <div className="p-5 flex justify-between gap-1 border-gray-250 border-b">
            <div className="flex flex-col">
              <h2 className="text-base font-semibold ">
                Order#
                
                {/* Main Order Number */}
                <span
                  onClick={(e) => copyText(orderDetailData?.orderNumber, e)}
                  className="cursor-pointer hover:underline"
                  title="Click to copy order number"
                >
                  {orderDetailData?.orderNumber}
                </span>

                {/* RH Platform Order Number */}
                {/* {orderDetailData?.platformOfOrder === "RH" &&
                  orderDetailData?.rhOrderJson?.orderNumber ? (
                  <span
                    onClick={(e) =>
                      copyText(orderDetailData?.rhOrderJson?.orderNumber, e)
                    }
                    className="cursor-pointer hover:underline ml-1"
                    title="Click to copy RH order number"
                  >
                    ({orderDetailData?.rhOrderJson?.orderNumber})
                  </span>
                ) : null} */}

                {(orderDetailData?.rhOrderNumber || orderDetailData?.rhOrderJson?.orderNumber) ? (
                    <span
                      onClick={(e) =>
                        copyText(orderDetailData?.rhOrderNumber || orderDetailData?.rhOrderJson?.orderNumber, e)
                      }
                      className="cursor-pointer hover:underline ml-1"
                      title="Click to copy RH order number"
                    >
                      ({orderDetailData?.rhOrderNumber || orderDetailData?.rhOrderJson?.orderNumber})
                    </span>
                  ) : null}
              </h2>
              <span className="inline-block w-fit rounded-md bg-[#F7F5F2] text-black text-sm font-normal p-1 whitespace-nowrap">
                {typeMapping[orderDetailData?.orderDeliveryType] || "Unknown Type"}
              </span>
              <p className="text-sm font-normal text-black">
                {/* The text below will change when the end status is updated. and also you can remove the the span tag at time of development.*/}
                {orderDetailData.status === "placed" ? (
                  rejectedText !== "" ? (
                    <span>{rejectedText} </span>
                  ) : (
                    <span>Order created on </span>
                  )
                ) : null}
                {orderDetailData.status === "confirmed" ? <span>Brief accepted on </span> : null}
                {orderDetailData.status === "processing" ? <span>Preparing on </span> : null}
                {orderDetailData.status === "under_qa" ? <span> In review by QC on </span> : null}
                {orderDetailData.status === "ready_to_pick" ? <span> Ready to Ship on </span> : null}
                {orderDetailData.status === "out_for_delivery" ? <span>Shipped on </span> : null}
                {orderDetailData.status === "pickup_delivered" ? <span> Ready to pickup on </span> : null}
                {orderDetailData.status === "no_show" ? <span>No Show on </span> : null}
                {orderDetailData.status === "cancelled" ? <span>Cancelled on </span> : null}
                {orderDetailData.status === "delivered" ? <span>Delivered/Completed on </span> : null}
                {orderDetailData.status === "reject" ? <span>Rejected on </span> : null}
                {formatDateFunction(updatedTime, "dd/mm/yyyy", true, "at")}
                <Link onClick={scrollToTrackingHistory} className="font-semibold text-[#176b53] underline ml-1">
                  Track History
                </Link>
              </p>
              {/* <h2 className="text-base font-semibold ">
                  {orderDetailData?.user?.vendorDetail?.storeName}
                </h2> */}
            </div>
            <div className="flex gap-1 grid-cols-4">
              {checkPermissionAction("Order Management", permissionJson, "deduction") &&
              !orderDetailData.deductionDetails &&
              orderDetailData.status !== "placed" &&
              orderDetailData.platformOfOrder !== "RH" ? (
                <Button type="primary" size={12} className="mx-0 cursor-pointer" onClick={() => setIsDeductionsModalOpen(true)}>
                  Deductions
                </Button>
              ) : null}

              {checkPermissionAction("Order Management", permissionJson, "download_invoice") &&
              orderDetailData.status !== "placed" &&
              orderDetailData.status !== "confirmed" &&
              (( orderDetailData.status === "processing" || orderDetailData.status === "under_qa") && orderDetailData.platformOfOrder !== "RH") &&
              orderDetailData?.orderDeliveryType !== "qc" ? (
                <Button
                  type="primary"
                  size={12}
                  className="mx-0 cursor-pointer"
                  onClick={() => {
                    downloadInvoice(orderDetailData.id);
                  }}
                >
                  Download Invoice
                </Button>
              ) : null}
              {checkPermissionAction("Order Management", permissionJson, "reactivate_order") &&
                orderDetailData.status === "cancelled" &&
                isAutoCancelledByCron() && (
                  <Button
                    type="primary"
                    size={12}
                    className="mx-0 cursor-pointer"
                    onClick={() => {
                      setIsReactivateModalOpen(true);
                    }}
                  >
                    Reactivate Order
                  </Button>
              )}
              {checkPermissionAction("Order Management", permissionJson, "resend_to_customer_approval") &&
              orderDetailData.status === "placed" ? (
                <Button
                  type="primary"
                  size={12}
                  className="mx-0 cursor-pointer"
                  onClick={() => {
                    setIsCustomerConfirmationModalOpen(true);
                    setMessageText("You want to send the order detail to customer.");
                    setModalStatus("");
                  }}
                >
                  Send to Customer Approval
                </Button>
              ) : null}
              {checkPermissionAction("Order Management", permissionJson, "moved_to_preparing") &&
              orderDetailData.status === "confirmed" &&
              orderDetailData?.orderDeliveryType !== "delivery" && ((orderDetailData.status === "confirmed" || orderDetailData.status === "processing" || orderDetailData.status === "under_qa") && orderDetailData?.platformOfOrder !== "RH") ? (
                <Button
                  type="primary"
                  size={12}
                  className="mx-0 cursor-pointer"
                  onClick={() => {
                    setIsCustomerConfirmationModalOpen(true);
                    setMessageText("You want to move this order to preparing.");
                    setModalStatus("processing");
                  }}
                >
                  Move to Preparing
                </Button>
              ) : null}
              {checkPermissionAction("Order Management", permissionJson, "submit_to_qc") &&
              (orderDetailData.status === "processing" || orderDetailData.status === "under_qa") &&
              orderDetailData.orderDeliveryType !== "delivery-payment" &&
              orderDetailData.orderDeliveryType !== "delivery" && ((orderDetailData.status === "confirmed" || orderDetailData.status === "processing" || orderDetailData.status === "under_qa") && orderDetailData?.platformOfOrder !== "RH") &&
              submitToQcBtn ? (
                <Button
                  type="primary"
                  size={12}
                  className="mx-0 cursor-pointer"
                  onClick={() => {
                    navigate("/submit-order-qc/" + orderDetailData.id);
                  }}
                >
                  Submit to QC
                </Button>
              ) : null}
              {checkPermissionAction("Order Management", permissionJson, "moved_to_ready_to_ship") &&
              ((orderDetailData.status === "processing" && orderDetailData.orderDeliveryType === "delivery-payment") ||
                (orderDetailData.status === "confirmed" && orderDetailData.orderDeliveryType === "delivery" && 
                ((orderDetailData.status === "confirmed" || orderDetailData.status === "processing" || orderDetailData.status === "under_qa") && orderDetailData?.platformOfOrder !== "RH"))) 
                ? (
                <Button
                  type="primary"
                  size={12}
                  className="mx-0 cursor-pointer"
                  onClick={() => {
                    setIsCustomerConfirmationModalOpen(true);
                    setMessageText("You want to move this order to ready to ship.");
                    setModalStatus("ready_to_pick");
                  }}
                >
                  Move to Ready To Ship
                </Button>
              ) : null}
            
              {orderDetailData.status === "pickup_delivered" && (
              <>
                {checkPermissionAction("Order Management", permissionJson, "move_to_complete") && (
                <Button
                  type="primary"
                  size={14}
                  className="mx-0 cursor-pointer"
                  onClick={() => {
                    setIsCustomerConfirmationModalOpen(true);
                    setMessageText("You want to move this order to completed.");
                    setModalStatus("delivered");
                    } }
                    >
                      Move to Complete
                  </Button>
                )}
                </>
              )}

              {checkPermissionAction("Order Management", permissionJson, "refund") &&
              orderDetailData.status === "delivered" &&
              Object.keys(orderDetailData.refund).length === 0 &&
              orderDetailData.orderDeliveryType !== "qc" ? (
                <Button type="primary" size={12} className="mx-0 cursor-pointer" onClick={() => setRefundOrderModel(true)}>
                  Refund Order
                </Button>
              ) : null}
              {(checkPermissionAction("Order Management", permissionJson, "delay_message") && orderDetailData.status === "ready_to_pick") ||
              orderDetailData.status === "out_for_delivery" ? (
                <Button
                  type="primary"
                  size={12}
                  className="mx-0 cursor-pointer"
                  onClick={() => {
                    setIsCustomerConfirmationModalOpen(true);
                    setMessageText("You want to send delay message.");
                    setModalStatus("delay_message");
                  }}
                >
                  Delay Message
                </Button>
              ) : null}
               {(
                  (orderDetailData?.platformOfOrder !== "RH" || !(orderDetailData.status === "confirmed" || orderDetailData.status === "processing" || orderDetailData.status === "under_qa"))
                  
                ) && (
                  <Dropdown overlay={editCancelMenu} placement="bottomRight" arrow={{ pointAtCenter: true }} trigger={["hover"]}>
                    <img src="images/dotsVertical.png" alt="Filter" className="w-[4px] h-[14px] m-2 cursor-pointer" />
                  </Dropdown>
                )}
            </div>
          </div>
          <OrderdetailTabs
            orderDetails={orderDetailData.orderDetails}
            vendorDetailsData={vendorDetailsData}
            status={orderDetailData.status}
            qcRequestData={qcRequestData}
            qcData={qcData}
            totalPrepTime={orderDetailData?.totalPrepTime}
            orderDeliveryType={orderDetailData?.orderDeliveryType}
          />
          {orderDetailData.orderDeliveryType !== "qc" ? (
            <Bills
              priceDetails={orderDetailData.priceDetails}
              refund={orderDetailData.refund}
              couponDetails={orderDetailData?.couponDetails}
              transactions={orderDetailData?.transactions}
            />
          ) : null}
          <DeliveryDetail orderDetailData={orderDetailData} permissionJson={permissionJson} setIsSelectRangeModalOpen={setIsSelectRangeModalOpen} isSelectRangeModalOpen={isSelectRangeModalOpen} handleSelectRangeModalCancel = {handleSelectRangeModalCancel} assignLockerToOrder={assignLockerToOrder} lockerDetails={lockerDetails} setselectedLockerNumber={setselectedLockerNumber}  selectedLockerNumber={selectedLockerNumber} handleSelectRangeModalOk = {handleSelectRangeModalOk}/>
          <div ref={trackingHistoryRef}>
            <TrackingHistory
              orderStatusLogs={orderDetailData.orderStatusLogs || []}
              whatsappNotificationLogs={orderDetailData.whatsappNotificationLogs || []}
            />
          </div>
          {orderDetailData.orderDeliveryType !== "delivery-payment" && qcRequestData.length ? (
            <QcDetails
              qcData={qcData}
              qcRequestData={qcRequestData}
              orderDetailData={orderDetailData}
              reloadPage={reloadPage}
              permissionJson={permissionJson}
            />
          ) : null}
          <BranchDetails branchDetails={orderDetailData.branchDetails || []} isGuestOrder={orderDetailData.isGuest} />
          {orderDetailData.deductionDetails ? <DeductionsDetails deductionDetails={orderDetailData.deductionDetails || []} /> : null}
          {(orderDetailData.status === "pickup_delivered" && lockerDetails?.deviceCode) ? <Divider /> : null}
          {/* The Driver Detail component  below will show when the end status is updated */}
          {orderDetailData.status !== "placed" &&
          orderDetailData.status !== "cancelled" &&
          // orderDetailData.status !== "confirmed" &&
          // orderDetailData.status !== "processing" &&
          // orderDetailData.status !== "under_qa" &&
          orderDetailData.orderDeliveryType !== "qc" &&
          orderDetailData.orderDeliveryType !== "qc-payment" &&
          orderDetailData.deliveryType === "fastest" ? (
            <DriverDetail
              orderId={orderDetailData.id || 0}
              driverDetails={orderDetailData.driverDetails || {}}
              status={orderDetailData.status}
              reloadPage={reloadPage}
              deliveryType={orderDetailData.deliveryType || ""}
              driver_pickup_time={orderDetailData.driver_pickup_time}
              deliveryDate={orderDetailData.deliveryDate}
              permissionJson={permissionJson}
            />
          ) : null}
          {orderDetailData.status !== "placed" &&
          orderDetailData.status !== "confirmed" &&
          orderDetailData.status !== "processing" &&
          orderDetailData.status !== "under_qa" &&
          orderDetailData.status !== "cancelled" &&
          orderDetailData.orderDeliveryType !== "qc" &&
          orderDetailData.orderDeliveryType !== "qc-payment" &&
          orderDetailData.deliveryType === "schedule" ? (
            <DriverDetail
              orderId={orderDetailData.id || 0}
              driverDetails={orderDetailData.driverDetails || {}}
              status={orderDetailData.status}
              reloadPage={reloadPage}
              deliveryType={orderDetailData.deliveryType || ""}
              driver_pickup_time={orderDetailData.driver_pickup_time}
              deliveryDate={orderDetailData.deliveryDate}
              permissionJson={permissionJson}
            />
          ) : null}
          
        
          {orderDetailData.orderDeliveryType !== "qc" && orderDetailData.orderDeliveryType !== "qc-payment" && (
            <DriverLogs driverAssignLogs={orderDetailData.driverAssignLogs || []} />
          )}
        </div>
      ) : (
        <div className="flex-auto pt-5 min-h-[490px] flex items-center justify-center">
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Orders are not Available" />
        </div>
      )}
      {/* {successMessageContextHolder} */}
      {/* {CancelMessageContextHolder} */}
      {isCustomerConfirmationModalOpen && (
        <CustomerConfirmation
          ReasonText="Are you sure?"
          MessageText={messageText}
          isOpen={isCustomerConfirmationModalOpen}
          onOk={handleCustomerConfirmationModalOk}
          onCancel={handleCustomerConfirmationModalCancel}
        />
      )}
      {isCancelOrderModel && (
        <CancelOrder
          ReasonText="Cancel Order"
          isOpen={isCancelOrderModel}
          onOk={handelCancelOrderModelOk}
          onCancel={handelCancelOrderModelCancel}
          orderDetailData={orderDetailData}
          // getAllOrdersCount={getAllOrdersCount}
        />
      )}
      {isRescheduleModel && (
        <Reschedule
          isOpen={isRescheduleModel}
          onOk={handelRescheduleModelOk}
          onCancel={handelRescheduleModelCancel}
          orderDetailData={orderDetailData}
        />
      )}
      {isRefundOrderModel && (
        <RefundOrder
          isOpen={isRefundOrderModel}
          onOk={handelRefundOrderModelOk}
          onCancel={handelRefundOrderModelCancel}
          orderDetailData={orderDetailData}
        />
      )}
      {isOtpModalOpen && (
        <Otp
          isOpen={isOtpModalOpen}
          onOk={handleOtpOk}
          onCancel={handleOtpCancel}
          verifyComplateOrderOtp={verifyComplateOrderOtp}
          orderDetailData={orderDetailData}
        />
      )}
      {isDeductionsModalOpen && (
        <Deductions
          isOpen={isDeductionsModalOpen}
          onOk={handelDeductionOrderModelOk}
          onCancel={handleDeductionsCancel}
          orderDetailData={orderDetailData}
        />
      )}
      {isReactivateModalOpen && (
        <CustomerConfirmation
          ReasonText="Are you sure reactivate order?"
          MessageText="This action will reactivate the order and send it to customer for approval. Are you sure you want to proceed?"
          isOpen={isReactivateModalOpen}
          onOk={reactivateCancelledOrder}
          onCancel={() => setIsReactivateModalOpen(false)}
        />
      )}
    </>
  );
};
export default OrderDetails;
